import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ie-lang-x",
  "use": "icon-ie-lang-x-usage",
  "viewBox": "0 0 1066 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1066 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ie-lang-x\">\n    <path d=\"M1052.16 512a318.57777813 318.57777813 0 1 0-637.1555552 0 318.57777813 318.57777813 0 0 0 637.1555552 0z\" fill=\"#2C2C2E\" p-id=\"4639\" />\n    <path d=\"M669.86666666 512a318.57777813 318.57777813 0 1 0-637.1555552 0 318.57777813 318.57777813 0 0 0 637.1555552 0z\" fill=\"#00D959\" p-id=\"4640\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol